// React
import React from 'react';

// Packages

// Utilities
import { getYears } from 'utilities';
import { useLabels } from 'utilities/hooks';
import { CONSTANTS } from 'utilities/configuration';

// Components
import {
    ResultReflections,
    ResultDetails,
    ResultChoice,
    ResultDataCard,
    ResultSetFieldValues,
} from '../_common';
import { ResultsKnowledgeDetails } from 'components/_cardContents/resultsKnowledge/resultsKnowledge';

const Name = CONSTANTS.RESULTS.KNOWLEDGE;

const Choice = props => {
    return ResultChoice({
        Name,
        methods: 'Initiative_Result__c.Knowledge_Type__c',
        fieldName: 'Knowledge_Type__c',
        ...props,
    });
};

const DataCard = ({ item, theme = 'teal', mode = [] }) => {
    return (
        <ResultDataCard
            {...{
                item,
                theme,
                methodsFieldName: 'Knowledge_Type__c',
                showDetails: mode.includes('details'),
            }}>
            <ResultsKnowledgeDetails {...{ item, theme }} />
        </ResultDataCard>
    );
};

const Details = props => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const { object, pickList } = useLabels();

    // ///////////////////
    // METHODS
    // ///////////////////

    function getItemData(formData) {
        const {
            Knowledge_Type__c,
            URL__c,
            Year__c,
            Availibility__c,
            DOI__c,
        } = formData;

        // Data for sf
        return {
            Knowledge_Type__c,
            DOI__c,
            URL__c,
            Year__c: Year__c?.length > 0 ? Year__c : null,
            Availibility__c,
        };
    }

    // ///////////////////
    // FIELDS
    // ///////////////////

    function fields() {
        return [
            {
                type: 'Text',
                name: 'URL__c',
                object: object.config('Initiative_Result__c.URL__c'),
                maxLength: 200,
            },
            {
                type: 'Text',
                name: 'DOI__c',
                object: object.config('Initiative_Result__c.DOI__c'),
                maxLength: 200,
            },
            {
                type: 'Select',
                name: 'Year__c',
                object: object.config(
                    'Initiative_Result__c.Year__c___Knowledge'
                ),
                options: getYears(),
            },
            {
                type: 'Select',
                name: 'Availibility__c',
                object: object.config('Initiative_Result__c.Availibility__c'),
                options: pickList('Initiative_Result__c.Availibility__c'),
            },
        ];
    }

    // ///////////////////
    // RETURN
    // ///////////////////

    return ResultDetails({
        fields,
        fieldSuffix: '___Knowledge',
        getItemData,
        ...props,
    });
};

const Reflections = props => {
    return ResultReflections({
        ...props,
    });
};

const setFieldValues = ({ choice, form, id, utilities, REPORT_ID }) => {
    // ///////////////////
    // DETAILS
    // ///////////////////

    const {
        Knowledge_Type__c,
        URL__c,
        DOI__c,
        Availibility__c,
        Year__c,
    } = utilities.results.get(id);

    form.setValue('Knowledge_Type__c', Knowledge_Type__c);
    form.setValue('Availibility__c', Availibility__c);
    form.setValue('URL__c', URL__c);
    form.setValue('DOI__c', DOI__c);
    form.setValue('Year__c', Year__c);

    // ///////////////////
    // ALL THE OTHER STUFF
    // ///////////////////

    ResultSetFieldValues({
        choice,
        form,
        id,
        utilities,
        REPORT_ID,
    });
};

export { Name, DataCard, Choice, Details, Reflections, setFieldValues };
